import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { status } from 'constants/general';
import generalStrings from 'modules/general/strings';
import Loader from 'modules/common/components/Loader';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  LoaderWrapper,
  Wrapper,
  Title,
  InsightsWrapper,
  InsightsBoxWrapper,
  InsightsBox,
  InsightsInfoWrapper,
  InsightsTitle,
  InsightsSubTitle,
  InsightsIcon,
} from './DashboardComponent.style';

const DashboardComponent = () => {
  const { campaignsInsights } = useSelector(state => ({
    campaignsInsights: state.general.campaignsInsights,
  }));

  const themeContent = useContext(ThemeContext);
  const { colors } = themeContent;

  const campaignInsightsData = campaignsInsights.details?.data;

  if (
    campaignsInsights.status === status.SHOULD_CALL_API ||
    campaignsInsights.status === status.FETCHING
  )
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );

  return (
    <Wrapper>
      <Title>{generalStrings.dashboard.campaignInsightsTitle}</Title>
      <SectionDivider gap={40} />
      <InsightsWrapper>
        <InsightsBox limitWidth>
          <InsightsInfoWrapper>
            <InsightsTitle>{campaignInsightsData?.totalCount || 0}</InsightsTitle>
            <SectionDivider gap={8} />
            <InsightsSubTitle>
              {generalStrings.dashboard.allCampaignsInsightsTitle}
            </InsightsSubTitle>
          </InsightsInfoWrapper>
          <InsightsIcon color={colors.white} backgroundColor={colors.blueMain} />
        </InsightsBox>
        <SectionDivider gap={30} />
        <InsightsBoxWrapper>
          <InsightsBox>
            <InsightsInfoWrapper>
              <InsightsTitle>{campaignInsightsData?.running || 0}</InsightsTitle>
              <SectionDivider gap={8} />
              <InsightsSubTitle>
                {generalStrings.dashboard.runningCampaignsInsightsTitle}
              </InsightsSubTitle>
            </InsightsInfoWrapper>
            <InsightsIcon color={colors.greenMain} backgroundColor={colors.greenLight} />
          </InsightsBox>
          <InsightsBox>
            <InsightsInfoWrapper>
              <InsightsTitle>{campaignInsightsData?.scheduled || 0}</InsightsTitle>
              <SectionDivider gap={8} />
              <InsightsSubTitle>
                {generalStrings.dashboard.scheduledCampaignsInsightsTitle}
              </InsightsSubTitle>
            </InsightsInfoWrapper>
            <InsightsIcon color={colors.blueMain} backgroundColor={colors.blueLight} />
          </InsightsBox>
          <InsightsBox>
            <InsightsInfoWrapper>
              <InsightsTitle>{campaignInsightsData?.expired || 0}</InsightsTitle>
              <SectionDivider gap={8} />
              <InsightsSubTitle>
                {generalStrings.dashboard.expiredCampaignsInsightsTitle}
              </InsightsSubTitle>
            </InsightsInfoWrapper>
            <InsightsIcon color={colors.orangeMain} backgroundColor={colors.orangeLight} />
          </InsightsBox>
          <InsightsBox>
            <InsightsInfoWrapper>
              <InsightsTitle>{campaignInsightsData?.inActive || 0}</InsightsTitle>
              <InsightsSubTitle>
                {generalStrings.dashboard.inactiveCampaignsInsightsTitle}
              </InsightsSubTitle>
            </InsightsInfoWrapper>
            <InsightsIcon color={colors.redMain} backgroundColor={colors.redLight} />
          </InsightsBox>
        </InsightsBoxWrapper>
      </InsightsWrapper>
    </Wrapper>
  );
};

export default DashboardComponent;
